import { Directive, OnInit } from '@angular/core';

import { NewRelicConfig } from './new-relic.config';
import { NewRelicService } from './new-relic.service';

@Directive({
  selector: '[assessNewRelicAppMeta]',
})
export class NewRelicAppMetaDirective implements OnInit {
  private readonly default = 'N/A';

  constructor(
    private readonly config: NewRelicConfig,
    private readonly newRelic: NewRelicService
  ) {}

  ngOnInit() {
    this.newRelic.addRelease('assess:version', this.config.version || this.default);
    this.newRelic.setCustomAttribute('assess:accountId', this.config.accountId || this.default);
    this.newRelic.setCustomAttribute('assess:customerId', this.config.customerId || this.default);
    this.newRelic.setCustomAttribute('assess:environmentId', this.config.environmentId || this.default);
    this.newRelic.setCustomAttribute('assess:version', this.config.version || this.default);
  }
}
